// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__1-5dN","Open":"Modal_Open__1EEwn"};